import { createApp, h } from 'vue'
import {createInertiaApp, Link} from '@inertiajs/inertia-vue3'
import store from './Store'
import {InertiaProgress} from "@inertiajs/progress";
import Layout from "./Shared/Layout";

import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
library.add(fas, far)

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import * as ConfirmDialog from 'vuejs-confirm-dialog'

import { createI18n } from 'vue-i18n';
import messages from './Translations/messages.js'
const i18n = createI18n({
    locale: 'cz',
    fallbackLocale: 'cz',
    messages,
});

import { ZiggyVue } from 'ziggy';
import { Ziggy } from './ziggy';
import moment from "moment";

const date = new Date()
if(date.getHours() > 18 || date.getHours() < 8) store.commit({type: 'setDarkMode'})

createInertiaApp({
    resolve: async name => {
        //let page = require(`./Pages/${name}`).default
        let page = await import(`./Pages/${name}`)

        page = page.default

        if(page.layout === undefined) {
            page.layout = Layout
        }
        return page
    },
    setup({ el, App, props, plugin }) {
        const vueapp =  createApp({ render: () => h(App, props) })
        vueapp.config.globalProperties.$filters = {
            dateTime(value) {
                return moment(String(value)).locale('cs').format('D.M.YYYY HH:mm')
            },
            date(value) {
                return moment(String(value)).locale('cs').format('D.M.YYYY')
            }
        }
        vueapp
            .use(plugin)
            .use(store)
            .use(i18n)
            .use(ZiggyVue, Ziggy)
            .component('Link', Link)
            .component('FontAwesomeIcon', FontAwesomeIcon)
            .mount(el)
    },
})

InertiaProgress.init({showSpinner: false});
